// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".reset-mobile-btn {\n  color: #e02b1d !important;\n  font-size: 20px;\n}\n", "",{"version":3,"sources":["webpack://src/components/resetFilterBtn/ResetFilterBtn.less"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,eAAA;AACJ","sourcesContent":[".reset-mobile-btn {\n    color: #e02b1d !important;\n    font-size: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
